export const isExternal = (value: string) => {
    return value.match(/^(https?:\/\/)|(^[^/]+\..+)/) !== null;
};
